import { render, staticRenderFns } from "./PvpRules.vue?vue&type=template&id=070b2c00"
import script from "./PvpRules.vue?vue&type=script&lang=js"
export * from "./PvpRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports